import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardComponent } from './components/card/card.component';
import { CardInteractiveComponent } from './components/card-interactive/card-interactive.component';
import { SharedUiButtonsModule } from '@shared/ui/buttons';
import { CardEvidenceComponent } from './components/card-evidence/card-evidence.component';
import { SharedUiInputsModule } from '@shared/ui/inputs';
import { SharedUiIconsModule } from '@shared/ui/icons';
import { SharedUtilsEvidenceManagementModule } from '@shared/utils/evidence-management';
import { SharedUtilsPipesModule } from '@shared/utils/pipes';
import { SharedUtilsTimeZonesModule } from '@shared/utils/time-zones';
import { CommentCardComponent } from './components/comment-card/comment-card.component';
import { CardInteractiveCheckboxComponent } from './components/card-interactive-checkbox/card-interactive-checkbox.component';
import { SharedUtilsDisableImageCachingModule } from '@shared/utils/disable-image-caching';
import { CardEvidenceVideoComponent } from './components/card-evidence-video/card-evidence-video.component';
import { InfoCardComponent } from './components/info-card/info-card.component';
import { CardModule } from 'primeng/card';
import { TooltipModule } from 'primeng/tooltip';

@NgModule({
  imports: [
    CommonModule,
    SharedUiButtonsModule,
    SharedUiInputsModule,
    SharedUiIconsModule,
    SharedUtilsEvidenceManagementModule,
    SharedUtilsPipesModule,
    SharedUtilsTimeZonesModule,
    SharedUtilsDisableImageCachingModule,
    CardModule,
    TooltipModule,
  ],
  declarations: [
    CardComponent,
    CardInteractiveComponent,
    CardEvidenceComponent,
    CommentCardComponent,
    CardInteractiveCheckboxComponent,
    CardEvidenceVideoComponent,
    InfoCardComponent,
  ],
  exports: [CardComponent, CardInteractiveComponent, CardEvidenceComponent, CommentCardComponent, CardInteractiveCheckboxComponent, CardEvidenceVideoComponent, InfoCardComponent],
})
export class SharedUiCardsModule {}
